import request from '@/utils/http';
import { PFX, SRM, SRM_FILE } from '../../constant/constant.js';

// 导入模板
export const downloadTemplate = data => {
    return request({
        url: `${PFX}/public/supplier/supplierInfo/downloadRegisterGuide`,
        method: 'post',
        data,
        responseType: 'arraybuffer',
    });
};

// 导出
export const exportResources = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierIdleDemandResources`,
        method: 'post',
        data
    });
};

// 查看匹配结果导出
export const exportMatchResources = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierIdleDemandResourcesMatch`,
        method: 'post',
        data,
    });
};

// ---------------------------------- 装卸 ----------------------------------

// 装卸-分页
export const searchLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/search`,
        method: 'post',
        data
    });
};

// 装卸-删除
export const deleteLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/deleteByIds`,
        method: 'post',
        data
    });
};

// 装卸-详情
export const getLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/${data}`,
        method: 'get',
    });
};

// 装卸-新增
export const addLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/add`,
        method: 'post',
        data,
    });
};

// 装卸-编辑
export const editLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/${data.id}`,
        method: 'put',
        data,
    });
};

// 装卸-保存并发布
export const releaseLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/saveRelease`,
        method: 'post',
        data,
    });
};

// 装卸-匹配
export const matchLoadIdleResources = data => {
    return request({
        url: `${SRM}/loadIdleResources/match`,
        method: 'post',
        data,
    });
};

// 装卸-查看匹配结果分页
export const searchLoadIdleResourcesMatch = data => {
    return request({
        url: `${SRM}/loadIdleResourcesMatch/search`,
        method: 'post',
        data,
    });
};

// 装卸-导入
export const importLoadIdle = (data, systemFlag) => {
    return request({
        url: `${SRM_FILE}/importSupplierLoadIdleResources/${systemFlag}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
    });
};

// ---------------------------------- 仓库 ----------------------------------

// 仓库-分页
export const searchWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/search`,
        method: 'post',
        data
    });
};

// 仓库-删除
export const deleteWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/deleteByIds`,
        method: 'post',
        data
    });
};

// 仓库-详情
export const getWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/${data}`,
        method: 'get',
    });
};

// 仓库-新增
export const addWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/add`,
        method: 'post',
        data,
    });
};

// 仓库-编辑
export const editWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/${data.id}`,
        method: 'put',
        data,
    });
};

// 仓库-保存并发布
export const releaseWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/saveRelease`,
        method: 'post',
        data,
    });
};

// 仓库-匹配
export const matchWarehouseIdleResources = data => {
    return request({
        url: `${SRM}/warehouseIdleResources/match`,
        method: 'post',
        data,
    });
};

// 仓库-查看匹配结果分页
export const searchWarehouseIdleResourcesMatch = data => {
    return request({
        url: `${SRM}/warehouseIdleResourcesMatch/search`,
        method: 'post',
        data,
    });
};

// 仓库-导入
export const importWarehouseIdle = (data, systemFlag) => {
    return request({
        url: `${SRM_FILE}/importSupplierWarehouseIdleResources/${systemFlag}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
    });
};

// ---------------------------------- 设备 ----------------------------------

// 设备-分页
export const searchEqIdleResources = data => {
    return request({
        url: `${SRM}/supplierEquipmentIdleResources/list`,
        method: 'post',
        data
    });
};

// 设备-删除
export const deleteEqIdleResources = data => {
    return request({
        url: `${SRM}/supplierEquipmentIdleResources/deleteBatch`,
        method: 'post',
        data
    });
};

// 设备-停用
export const disableEqIdleResources = data => {
    return request({
        url: `${SRM}/supplierEquipmentIdleResources/disable`,
        method: 'post',
        data
    });
};

// 设备-新增
export const addEqIdleResources = data => {
    return request({
        url: `${SRM}/supplierEquipmentIdleResources/add`,
        method: 'post',
        data,
    });
};

// 设备-编辑
export const editEqIdleResources = data => {
    return request({
        url: `${SRM}/supplierEquipmentIdleResources/update/${data.id}`,
        method: 'put',
        data,
    });
};

// 设备-导入
export const importEquipmentIdle = (data, systemFlag) => {
    return request({
        url: `${SRM_FILE}/importSupplierEquipmentIdleResources/${systemFlag}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
    });
};
